@if (tabs && tabs.length > 1) {
    <ul class="nav-bar-tabs">
        @for (tab of tabs; track tab.url) {
            <li (click)="navigateTo(tab)"
            [class.active]="tab.isSelected" [captureId]="tab.key">
            <span [i18nKey]="tab.key"></span>
        </li>
        }
    </ul>
}
